/* =========================================================
   BRHM GYAAN HERO SLIDER
   Stable Infinite Slider + Zoom + Content Animation
   + Image Particles
========================================================= */

(function () {

  'use strict';


  function initBRHMHeroSlider(section) {

    if (!section) return;

    /* Prevent duplicate initialization */
    if (section.dataset.brhmHeroInitialized === 'true') {
      return;
    }

    section.dataset.brhmHeroInitialized = 'true';


    /* =====================================================
       ELEMENTS
    ===================================================== */

    const slides = Array.from(
      section.querySelectorAll('.brhm-hero-slide')
    );

    const dots = Array.from(
      section.querySelectorAll('.brhm-hero-slider__dot')
    );

    const nextBtn = section.querySelector(
      '.brhm-hero-slider__arrow--next'
    );

    const prevBtn = section.querySelector(
      '.brhm-hero-slider__arrow--prev'
    );


    if (!slides.length) return;


    /* =====================================================
       SETTINGS
    ===================================================== */

    const autoplay =
      section.dataset.autoplay !== 'false';

    const duration =
      parseInt(section.dataset.duration, 10) || 6000;


    /* =====================================================
       STATE
    ===================================================== */

    let current = 0;
    let timer = null;
    let isAnimating = false;


    /* =====================================================
       GSAP
    ===================================================== */

    const GSAP = window.gsap || null;


    /* =====================================================
       HELPERS
    ===================================================== */

    function getImage(slide) {

      const mobileImage =
        slide.querySelector(
          '.brhm-hero-slide__image--mobile'
        );

      const desktopImage =
        slide.querySelector(
          '.brhm-hero-slide__image--desktop'
        );


      if (
        window.innerWidth <= 767 &&
        mobileImage
      ) {
        return mobileImage;
      }


      return desktopImage || mobileImage;
    }


    function getContent(slide) {

      return slide.querySelectorAll(
        '.brhm-hero-slide__eyebrow,' +
        '.brhm-hero-slide__heading,' +
        '.brhm-hero-slide__description,' +
        '.brhm-hero-slide__buttons,' +
        '.brhm-hero-slide__features'
      );

    }


    /* =====================================================
       RESET SLIDE
    ===================================================== */

    function resetSlide(slide) {

      const image = getImage(slide);
      const content = getContent(slide);
      const canvas =
        slide.querySelector('.brhm-hero-particles');


      if (GSAP) {

        GSAP.killTweensOf(slide);
        GSAP.killTweensOf(image);
        GSAP.killTweensOf(content);


        if (image) {

          GSAP.set(image, {
            opacity: 1,
            scale: 1.08
          });

        }


        if (content.length) {

          GSAP.set(content, {
            opacity: 0,
            y: 35
          });

        }

      } else {

        if (image) {

          image.style.opacity = '1';
          image.style.transform = 'scale(1.08)';

        }


        content.forEach(function (item) {

          item.style.opacity = '0';
          item.style.transform =
            'translateY(35px)';

        });

      }


      if (canvas) {

        canvas.classList.add('is-hidden');
        canvas.style.opacity = '0';

      }

    }


    /* =====================================================
       CONTENT ANIMATION
    ===================================================== */

    function animateContent(slide) {

      const content = getContent(slide);

      if (!content.length) return;


      if (GSAP) {

        GSAP.killTweensOf(content);


        GSAP.to(content, {

          opacity: 1,

          y: 0,

          duration: 0.75,

          stagger: 0.12,

          ease: 'power3.out'

        });

      } else {

        content.forEach(function (item, index) {

          setTimeout(function () {

            item.style.transition =
              'opacity .7s ease, transform .7s ease';

            item.style.opacity = '1';

            item.style.transform =
              'translateY(0)';

          }, index * 120);

        });

      }

    }


    /* =====================================================
       IMAGE ZOOM
    ===================================================== */

    function animateImage(slide) {

      const image = getImage(slide);

      if (!image) return;


      if (GSAP) {

        GSAP.killTweensOf(image);


        /*
          IMPORTANT:
          Image remains visible.
          Only scale changes.
        */

        GSAP.set(image, {
          opacity: 1,
          scale: 1.08
        });


        GSAP.to(image, {

          opacity: 1,

          scale: 1,

          duration: 2.2,

          ease: 'power2.out'

        });

      } else {

        image.style.opacity = '1';

        image.style.transform =
          'scale(1)';

      }

    }


    /* =====================================================
       PARTICLE EFFECT
       Lightweight version
    ===================================================== */

    function particleReveal(slide) {

      const canvas =
        slide.querySelector('.brhm-hero-particles');

      if (!canvas) return;


      /*
        We don't allow particles to block
        the actual slider.
      */

      canvas.classList.remove('is-hidden');

      canvas.style.opacity = '0';


      if (GSAP) {

        GSAP.to(canvas, {

          opacity: 0.55,

          duration: 0.35,

          ease: 'power2.out',

          onComplete: function () {

            GSAP.to(canvas, {

              opacity: 0,

              duration: 1.2,

              ease: 'power2.out',

              onComplete: function () {

                canvas.classList.add(
                  'is-hidden'
                );

              }

            });

          }

        });

      } else {

        canvas.style.opacity = '0';

        canvas.classList.add(
          'is-hidden'
        );

      }

    }


    /* =====================================================
       DOTS
    ===================================================== */

    function updateDots(index) {

      dots.forEach(function (dot, i) {

        const active = i === index;

        dot.classList.toggle(
          'is-active',
          active
        );

        dot.setAttribute(
          'aria-selected',
          active ? 'true' : 'false'
        );

      });

    }


    /* =====================================================
       SHOW SLIDE
    ===================================================== */

    function showSlide(index, direction) {

      if (isAnimating) return;

      if (slides.length <= 1) return;


      /* Infinite index */

      if (index >= slides.length) {
        index = 0;
      }

      if (index < 0) {
        index = slides.length - 1;
      }


      if (index === current) return;


      isAnimating = true;


      const oldSlide =
        slides[current];

      const newSlide =
        slides[index];


      /* =================================================
         STOP OLD SLIDE
      ================================================= */

      if (GSAP) {

        GSAP.killTweensOf(oldSlide);

        GSAP.killTweensOf(
          getContent(oldSlide)
        );

      }


      oldSlide.classList.remove(
        'is-active'
      );


      /*
        Immediately hide old slide.
        Don't wait for GSAP callback.
      */

      oldSlide.style.opacity = '0';


      /* =================================================
         PREPARE NEW SLIDE
      ================================================= */

      resetSlide(newSlide);


      newSlide.style.opacity = '1';

      newSlide.classList.add(
        'is-active'
      );


      current = index;


      updateDots(current);


      /* =================================================
         IMAGE
      ================================================= */

      animateImage(newSlide);


      /* =================================================
         PARTICLES
      ================================================= */

      particleReveal(newSlide);


      /* =================================================
         CONTENT
      ================================================= */

      setTimeout(function () {

        animateContent(newSlide);

      }, 250);


      /* =================================================
         FINISH
      ================================================= */

      setTimeout(function () {

        isAnimating = false;

        restartAutoplay();

      }, 500);

    }


    /* =====================================================
       FIRST SLIDE
    ===================================================== */

    function startSlider() {

      slides.forEach(function (slide, index) {

        slide.classList.remove(
          'is-active'
        );

        slide.style.opacity =
          '0';

        resetSlide(slide);

      });


      const first =
        slides[0];


      first.classList.add(
        'is-active'
      );

      first.style.opacity =
        '1';


      current = 0;


      updateDots(0);


      /* First image */

      animateImage(first);


      /* First content */

      setTimeout(function () {

        animateContent(first);

      }, 400);


      restartAutoplay();

    }


    /* =====================================================
       AUTOPLAY
    ===================================================== */

    function restartAutoplay() {

      if (timer) {

        clearTimeout(timer);

        timer = null;

      }


      if (
        !autoplay ||
        slides.length <= 1
      ) {

        return;

      }


      timer = setTimeout(function () {

        showSlide(
          current + 1,
          'next'
        );

      }, duration);

    }


    /* =====================================================
       NEXT
    ===================================================== */

    if (nextBtn) {

      nextBtn.addEventListener(
        'click',
        function () {

          if (timer) {
            clearTimeout(timer);
          }

          showSlide(
            current + 1,
            'next'
          );

        }
      );

    }


    /* =====================================================
       PREVIOUS
    ===================================================== */

    if (prevBtn) {

      prevBtn.addEventListener(
        'click',
        function () {

          if (timer) {
            clearTimeout(timer);
          }

          showSlide(
            current - 1,
            'prev'
          );

        }
      );

    }


    /* =====================================================
       DOTS
    ===================================================== */

    dots.forEach(function (dot, index) {

      dot.addEventListener(
        'click',
        function () {

          if (timer) {
            clearTimeout(timer);
          }

          showSlide(
            index,
            index > current
              ? 'next'
              : 'prev'
          );

        }
      );

    });


    /* =====================================================
       HOVER PAUSE
    ===================================================== */

    section.addEventListener(
      'mouseenter',
      function () {

        if (timer) {

          clearTimeout(timer);

          timer = null;

        }

      }
    );


    section.addEventListener(
      'mouseleave',
      function () {

        restartAutoplay();

      }
    );


    /* =====================================================
       SHOPIFY THEME EDITOR
    ===================================================== */

    document.addEventListener(
      'shopify:section:unload',
      function (event) {

        if (
          event.target === section ||
          section.contains(event.target)
        ) {

          if (timer) {

            clearTimeout(timer);

          }

        }

      }
    );


    /* =====================================================
       START
    ===================================================== */

    startSlider();

  }


  /* =======================================================
     GLOBAL INIT
  ======================================================= */

  function initBRHMHero() {

    document
      .querySelectorAll('[data-brhm-hero]')
      .forEach(function (section) {

        initBRHMHeroSlider(section);

      });

  }


  /* =======================================================
     DOM READY
  ======================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initBRHMHero
    );

  } else {

    initBRHMHero();

  }


  /* =======================================================
     SHOPIFY SECTION LOAD
  ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          '[data-brhm-hero]'
        );


      if (section) {

        initBRHMHeroSlider(section);

      }

    }
  );

})();



// cursor
/* =========================================
   BRHM GYAAN - CUSTOM CURSOR
========================================= */

(function () {
  'use strict';

  function initBRHMCursor() {

    const cursor = document.querySelector('.brhm-cursor');

    if (!cursor) return;

    /* Make sure cursor is directly inside body */
    if (cursor.parentElement !== document.body) {
      document.body.appendChild(cursor);
    }

    /* Mouse move */
    document.addEventListener('pointermove', function (e) {

      cursor.style.transform =
        'translate3d(' +
        e.clientX +
        'px, ' +
        e.clientY +
        'px, 0) translate3d(-50%, -50%, 0)';

    }, { passive: true });


    /* Hover */
    const hoverElements = document.querySelectorAll(
      'a, button, input, textarea, select, label, .brhm-hover'
    );

    hoverElements.forEach(function (element) {

      element.addEventListener('pointerenter', function () {
        cursor.classList.add('is-hover');
      });

      element.addEventListener('pointerleave', function () {
        cursor.classList.remove('is-hover');
      });

    });


    /* Click */
    document.addEventListener('pointerdown', function () {
      cursor.classList.add('is-click');
    });

    document.addEventListener('pointerup', function () {
      cursor.classList.remove('is-click');
    });

  }


  /* Start */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initBRHMCursor
    );

  } else {

    initBRHMCursor();

  }

})();